/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ExportOriginalIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Export Original',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M12 21v-6a1 1 0 0 1 1-1h13V5a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-9H13a1 1 0 0 1-1-1Z"
    />
    <path
      d="M28 11.207V16H14.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H28v4.793a.5.5 0 0 0 .854.353L35.913 18l-7.059-7.146a.5.5 0 0 0-.854.353Z"
    />
  </svg>`;
};
